import React, { useCallback, useLayoutEffect } from 'react';
import {
  useRecoilValue,
  useRecoilValueLoadable,
  useSetRecoilState,
} from 'recoil';
import {
  getQuestionScenarioQuery,
  questionIdState, scenarioQuery,
  tokenState,
} from '../stores/query';
import WebInterview from '../components/webinterview/WebInterview';
import { FormValues } from '../stores/formState';
import { RawScenario } from '../types/rawScenario';
import { applyFormToRawScenario, applyAnswerStatusToRawScenario } from '../utils/applier';
import { setQuestionAnswer } from '../api/setQuestionScenario';
import { scenarioState } from '../stores/scenarioState';
import { usingScenarioItemsState } from '../stores/skippedScenarioItemsState';
import { ErrorBoundary } from '../components/error/ErrorBoundary';

interface ListPageProp {
  token: string;
}

const MainPage = (props: ListPageProp) => {
  if (props.token === null) {
    return (<h1>404 Page Not Found.</h1>)
  }
  return (
    <React.Suspense fallback={"loading..."}>
      <ErrorBoundary>
        <MainPageInner/>
      </ErrorBoundary>
    </React.Suspense>
  );
};

const MainPageInner = () => {
  const token = useRecoilValue(tokenState);
  const questionId = useRecoilValue(questionIdState);
  const rawScenario = useRecoilValueLoadable(getQuestionScenarioQuery);
  const originalScenario = useRecoilValueLoadable(scenarioQuery);
  const setScenario = useSetRecoilState(scenarioState);
  const {state, contents} = useRecoilValueLoadable(scenarioState);
  const usingItems = useRecoilValueLoadable(usingScenarioItemsState);

  useLayoutEffect(() => {
    if (originalScenario.state === 'hasValue') {
      setScenario(originalScenario.contents);
    }
    if (originalScenario.state === 'hasError') {
      console.error(originalScenario.errorMaybe());
    }
  }, [originalScenario, originalScenario.state, originalScenario.contents, setScenario]);

  const complete = useCallback((form: FormValues) => {
    if (rawScenario.state !== 'hasValue') return;
    const scenarioClone: RawScenario = JSON.parse(JSON.stringify(rawScenario.contents));
    applyFormToRawScenario(scenarioClone, form);
    applyAnswerStatusToRawScenario(scenarioClone, usingItems.getValue())
    setQuestionAnswer({
      token: token,
      questionId: questionId!,
      scenarioBasicInfo: scenarioClone.scenarioBasicInfo,
      scenarioPageInfo: scenarioClone.scenarioPageInfo,
      personalInfo: scenarioClone.personalInfo,
    });
  }, [token, questionId, rawScenario, usingItems]);

  if (rawScenario.state === 'hasError') {
    return (<h1>{rawScenario.contents.message}</h1>)
  }

  switch (state) {
    case 'loading':
      return (<span>Loading...</span>);
    case 'hasError':
      return (<h1>Error {contents} </h1>)
    case 'hasValue':
      return (<WebInterview onCompleted={complete}/>);
  }
}

export default MainPage;
